import { FC, SVGProps } from 'react'

import { cn } from 'src/lib/cn'
import { cva, VariantProps } from 'src/lib/cva'

const DropdownBoldArrowIconVariants = cva('w-4 h-2', {
  variants: {
    direction: {
      up: 'rotate-180',
      down: '',
      left: 'rotate-90',
      right: '-rotate-90',
    },
  },
  defaultVariants: {
    direction: 'down',
  },
})

const DropdownBoldArrowIcon: FC<
  SVGProps<SVGSVGElement> & VariantProps<typeof DropdownBoldArrowIconVariants>
> = ({ direction, className, ...props }) => {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(DropdownBoldArrowIconVariants({ direction }), className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23558 1.04909C9.68189 1.4954 9.68189 2.21902 9.23558 2.66533L5.80701 6.09391C5.36069 6.54022 4.63708 6.54022 4.19076 6.09391L0.762191 2.66533C0.315877 2.21902 0.315877 1.4954 0.762191 1.04909C1.2085 0.602777 1.93212 0.602777 2.37844 1.04909L4.99888 3.66954L7.61933 1.04909C8.06565 0.602777 8.78926 0.602777 9.23558 1.04909Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default DropdownBoldArrowIcon
